import { palette } from "@callcenter/design-system"

type MetaTagDescriptor = ({ name: string } | { property: string }) & { content: string } & Record<string, string>

export const setMetaTag = (descriptor: MetaTagDescriptor): void => {
  const selectorAttribute = "name" in descriptor ? "name" : "property"
  const selectorValue = descriptor[selectorAttribute]
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${selectorAttribute}="${selectorValue}"]`)

  if (!tag) {
    tag = document.createElement("meta")
    document.head.appendChild(tag)
  }

  Object.entries(descriptor).forEach(([key, value]) => tag.setAttribute(key, value))
}

const STATIC_META_TAGS: ReadonlyArray<MetaTagDescriptor> = [
  { name: "viewport", content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" },
  { name: "theme-color", content: palette.backgroundDark },
  { name: "msapplication-TileColor", content: "#333333" },
  { name: "mobile-web-app-capable", content: "yes" },
  { name: "apple-mobile-web-app-status-bar-style", content: palette.backgroundDark },
  { property: "og:type", content: "website" }
]

export const applyStaticMetaTags = (): void => {
  STATIC_META_TAGS.forEach(setMetaTag)
}
